var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"checkbox-wrapper modal-register-conditions-sms"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","id":"register-sms"}}),_c('label',{attrs:{"for":"remember"}},[_vm._v("Я согласен(на) получать важные уведомления по SMS")])])
}]

export { render, staticRenderFns }